import {createAction} from '@reduxjs/toolkit'

export const toggleVirtualPhoneNumberUsing = createAction('pickup/toggleVirtualPhoneNumberUsing')

export const toggleReceiverModified = createAction('pickup/toggleReceiverModified')

export const changePhoneNumber = createAction('pickup/changePhoneNumber', (phoneNumber: string) => {
    return {payload: phoneNumber}
})
